<template>
    <li class="card">
        <div class="card__inner">
            <a v-if="closable" @click="$emit('cardClosed')" class="card__close">×</a>
            <slot></slot>
        </div>
    </li>
</template>

<script>
    export default {
        name: 'Card',
        props: {
            closable: Boolean,
            closeData: Object,
        }
    }
</script>

<style lang="scss" scoped>
    .card {
        position: relative;
        flex: 1 0 auto;
        padding: $card-margin;
        display: flex;
        flex-flow: row nowrap;

        &, * {
            white-space: normal;
        }

        &__inner {
            background: $card-background-color;
            border: 1px solid #DDDDDD;
            box-sizing: border-box;
            box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.0647928);
            border-radius: 4px;
            padding: $card-margin;
            width: 100%;
            height: 100%;
            flex: 1 0 auto;
            max-width: 100%;
            display: block;
            position: relative;
        }

        &__close {
            position: absolute;
            z-index: 200;
            right: 5px;
            top: 5px;
            text-shadow: 0 0 6px rgba(0, 0, 0, 0.50);
            color: #FFF;
            font-size: 32px;
            cursor: pointer;
            display: block;
            height: 52px;
            width: 52px;
            line-height: 32px;
            padding: 10px;
            text-align: center;

            &:hover {
                text-shadow: 0 0 6px $black;
            }
        }
    }
</style>